/**
 * Card genérico de campo de texto livre — usado para Objetivo, Saúde
 * e Observações no perfil do aluno.
 *
 * 3 seções diferentes do perfil tinham o MESMO padrão (título + card
 * + texto/textarea condicional ao isEditing) com pequenas variações
 * (multi-linha, placeholder, empty text). Em vez de copiar 3 vezes,
 * generalizei aqui.
 *
 * Props:
 *   - title: rótulo da seção (ex: "Objetivo", "Saúde / Restrições")
 *   - value: texto atual em modo view (vem de `student.goal` etc)
 *   - editValue: valor controlado em modo edição
 *   - onChangeText: setter do TextInput
 *   - isEditing: alterna view ↔ edit
 *   - multiline: renderiza textarea (default false)
 *   - emptyText: o que mostrar quando value for vazio (default "—")
 *   - placeholder: placeholder do TextInput
 *
 * Quando NÃO usar: se a seção tem comportamento ESPECIAL (link,
 * formato, validação), crie componente próprio em vez de adaptar
 * este aqui com mais props.
 */

import { memo } from 'react';
import { View, Text, TextInput } from 'react-native';
import { sharedStyles } from './styles';

interface Props {
  title: string;
  value: string | null | undefined;
  editValue: string;
  onChangeText: (v: string) => void;
  isEditing: boolean;
  multiline?: boolean;
  emptyText?: string;
  placeholder?: string;
}

function TextFieldSectionImpl({
  title, value, editValue, onChangeText, isEditing,
  multiline = false, emptyText = '—', placeholder,
}: Props) {
  return (
    <>
      <Text style={sharedStyles.sectionTitle}>{title}</Text>
      <View style={sharedStyles.card}>
        {isEditing ? (
          <TextInput
            style={multiline ? [sharedStyles.input, sharedStyles.inputMultiline] : sharedStyles.input}
            value={editValue}
            onChangeText={onChangeText}
            placeholder={placeholder}
            multiline={multiline}
            numberOfLines={multiline ? 3 : undefined}
          />
        ) : (
          <Text style={[sharedStyles.bodyText, !value && { color: '#bbb' }]}>
            {value || emptyText}
          </Text>
        )}
      </View>
    </>
  );
}

export const TextFieldSection = memo(TextFieldSectionImpl);
